const API_BASE_URL = process.env.REACT_APP_BASE_API_URL;

export const deleteLeadApi = async (leadId) => {
    console.log(leadId)
    const token = localStorage.getItem('token');

    if (!token) {
        throw new Error('Токен авторизации не найден.');
    }

    try {
        const response = await fetch(
            `${API_BASE_URL}/admin/lead/leads/${leadId}`,
            {
                method: 'DELETE',
                headers: {
                    'Accept': 'application/json', 
                    'Authorization': `Bearer ${token}`,
                },
            }
        );

        console.log(response)

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData?.message || `Ошибка при удалении лида #${leadId}`);
        }
        
        return response.status === 204 ? response : await response.json();

    } catch (error) {
        console.error(`Ошибка при удалении лида с ID ${leadId}:`, error);
        throw error;
    }
};